import { useReduxState } from 'hooks';
import { ApiDownloadButton } from 'components/common';
import { useBoxContext } from 'components/common/box';

import type {
  IndividualAchievement,
  SortIndividualAchievements
} from 'shared-types';

interface Props {
  individualAchievements: IndividualAchievement[];
  sortBy: SortIndividualAchievements['sortBy'];
  titleSearch?: string;
}

const AchievementsIndividualExport = ({
  individualAchievements,
  sortBy,
  titleSearch
}: Props) => {
  const { selectedItems } = useBoxContext();

  const { messages } = useReduxState();

  const selectedIndividualAchievementIds = Object.keys(selectedItems).map(
    (key) => Number(key)
  );

  return (
    <ApiDownloadButton
      disabled={!individualAchievements?.length}
      filename={`${messages.individualAchievements}.xlsx`}
      icon="file-excel"
      isDropdown={true}
      packet={{ individualAchievementIds: selectedIndividualAchievementIds }}
      text={messages.commonExportToExcel}
      url={`/admin/achievements-individual/excel-export?sortBy=${sortBy}&titleSearch=${titleSearch}`}
    />
  );
};

export default AchievementsIndividualExport;
